export default {
  date: 'March 7, 2024',
  title: 'The new «Ruler» tool!',
  description: 'Elevate your presentations and sales effectiveness with our latest feature!',
  id: 'ruler',
  jsx: () => (
    <div class='novelty__text'>
      <p>Elevate your presentations and sales effectiveness with our latest feature!</p>
      <p>
        «Ruler» Feature: This new function in our virtual tours allows for precise measurements of furniture sizes and distances between multiple points in a space. It will enable your clients to select the right-sized furniture and accurately estimate the quantity of the materials needed for
        renovations.
      </p>
      <p>How to use the "Ruler" tool? It's simple:</p>
      <p>
        1. Click on the ruler icon.
        <br></br>
        2. When the circle appears, click – this will be the first measurement point.
        <br></br>
        3. Move the cursor and click to set the second point. The measurement in meters and feet will appear. You can easily reset the measurement by clicking or continue measuring as needed.
      </p>
      <p>This tool will become an indispensable assistant in your work, providing accurate data and enhancing your virtual tours. Enjoy the benefits of the "Ruler" from Getfloorplanand make successful deals! Thank you for your attention, and we wish you productive work with our tools!</p>
      <p>When placing an order, enter the promo code RULER, and receive this tool as a gift with any package you choose.</p>
      <p>Don't miss the opportunity to avail of this feature for free until April 31, 2024.</p>
    </div>
  ),
  thumb: 'news/7.webp',
};
